import { C as Cart } from './cart-eLzX7E8s.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './notyf-DIw0RvBj.js';
import './uniq-D7II7obF.js';

class CartItems extends HTMLElement {
  #unsubscribers = [];

  static {
    Cart.sections.push('fetch-line-items');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:change'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => this.#renderSections(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Render the sections.
   * @param {Object} sections - The sections to render.
   */
  #renderSections(sections) {
    const html = parseHTML(sections['fetch-line-items']);
    const target = html.querySelector('line-items');
    this.innerHTML = target.innerHTML;
  }
}

customElements.define('line-items', CartItems);
